import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { authManager, loggedOutRedirect, okta } from 'lib-shared-auth';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { dixaWidgetPurgeUser } from 'components/widget/utils/widget';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

/** A component that displays a modal for logging out the agent. */
export const LogOutModal = createAppModal(
  { type: 'app:logOut' },
  ({ isOpen, hide }): JSX.Element => {
    const dispatch = useAppDispatch();
    const loginType = useAppSelector((state) => state.app.logInType);

    /** Handles the modal confirm action. */
    const handleConfirm = useCallback(async () => {
      const authData = await authManager.getAuthData();

      if (authData?.refresh_token) {
        await dispatch(
          appActions.logOut({ refreshToken: authData.refresh_token }),
        );

        dixaWidgetPurgeUser();
        authManager.removeAuthData();
        ampli.flush();

        if (loginType === 'oktaClient') {
          okta.logOut();
        } else {
          loggedOutRedirect();
        }

        ampli.signOutConfirmed();
      }
    }, [dispatch, loginType]);

    /** Handles the modal cancel action. */
    const handleCancel = useCallback(() => {
      ampli.signOutAborted();
      hide();
    }, [hide]);

    return (
      <Modal isOpen={isOpen} onClose={handleCancel}>
        <ModalHead title="Sign out" onClose={handleCancel} />

        <ModalBody>Are you sure you want to sign out?</ModalBody>

        <ModalFoot
          cancelName="No, stay online"
          cancelOnClick={handleCancel}
          cancelProps={{
            variant: 'secondary',
          }}
          confirmName="Yes, sign me out"
          confirmOnClick={handleConfirm}
          confirmProps={{
            variant: 'danger',
            id: 'logOutButton',
          }}
        />
      </Modal>
    );
  },
);
